function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function parsePossiblyJson(payload?: string): unknown | null {
  if (!payload) {
    return null;
  }

  try {
    return JSON.parse(payload);
  } catch {
    return null;
  }
}

export function formatPossiblyJson(payload?: string): string {
  const parsed = parsePossiblyJson(payload);

  if (parsed === null) {
    return payload ?? '';
  }

  return JSON.stringify(parsed, null, 2);
}

export function extractSolverLog(payload?: string): string {
  const parsed = parsePossiblyJson(payload);

  if (!isRecord(parsed)) {
    return '';
  }

  const schoolTimetablingProblem = parsed.schoolTimetablingProblem;

  if (!isRecord(schoolTimetablingProblem)) {
    return '';
  }

  return typeof schoolTimetablingProblem.log === 'string' ? schoolTimetablingProblem.log : '';
}
